import { UserAccounts } from "services";
import { FingerprintDisplayClasses, FingerprintJsx } from "../components";
import { Fingerprint } from "../constants";
import { useAccounts } from "./useAccounts";

interface UseFingerprintDisplayProps extends FingerprintDisplayClasses {
    fingerprint?: Fingerprint;
}
interface UseFingerprintDisplayReturn {
    hasCreated: boolean;
    hasUpdated: boolean;
    hasBoth: boolean;
    created: JSX.Element | null;
    updated: JSX.Element | null;
    accounts?: UserAccounts[];
}
export const useFingerprintDisplay = (
    props: UseFingerprintDisplayProps
): UseFingerprintDisplayReturn => {
    const { fingerprint, ...classes } = props;

    let accountUids: string[] | undefined = undefined;
    let createdIndex: number | null = null;
    let updatedIndex: number | null = null;
    let created: JSX.Element | null = null;
    let updated: JSX.Element | null = null;

    if (fingerprint) {
        accountUids = [];

        if (fingerprint.createdBy) {
            createdIndex = 0;
            accountUids.push(fingerprint.createdBy);
        }

        if (fingerprint.lastUpdatedBy) {
            if (fingerprint.lastUpdatedBy !== fingerprint.createdBy) {
                updatedIndex = createdIndex == null ? 0 : 1;
                accountUids.push(fingerprint.lastUpdatedBy);
            } else updatedIndex = 0;
        }
    }

    const { data: accounts, isLoading, isError } = useAccounts(accountUids);

    if (!isLoading && !isError && accounts) {
        if (createdIndex !== null)
            created = (
                <FingerprintJsx
                    user={accounts[createdIndex]}
                    value="created"
                    time={fingerprint?.created}
                    {...classes}
                />
            );

        if (updatedIndex !== null)
            updated = (
                <FingerprintJsx
                    user={accounts[updatedIndex]}
                    value="lastUpdated"
                    time={fingerprint?.lastUpdated}
                    {...classes}
                />
            );
    }

    const hasCreated = createdIndex !== null;
    const hasUpdated = updatedIndex !== null;
    return {
        hasCreated,
        hasUpdated,
        hasBoth: hasCreated && hasUpdated,
        created,
        updated,
        accounts,
    };
};
